/* eslint-disable react/no-string-refs */
/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ReceiptUpload.css";
import PropTypes from "prop-types";

class ReceiptUpload extends Component {
  constructor(props) {
    super(props);
    try {
      if (this.props.location.state.amount) {
        this.state = {
          ...this.props.location.state,
          fetching: true,
          status: "",
        };
      }
    } catch (e) {
      this.props.history.push({
        pathname: "/SelectMission",
      });
    }
  }

  render() {
    /* if (this.state.fetching || this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }
      */


    const languageObj = this.props.languageObj;


    const paymentMethodNames = {
      alipay: "Alipay",
      wechatpay: "WeChat Pay",
      bocpay: "BoC Pay",
      octopus: "Octopus",
      bank_transfer: "Bank Transfer",
      check_writing: "Cheque",
      // Add more payment methods as needed
    };

    const paymentMethodColors = {
      alipay: { background: "#00A1ED", text: "#00A1ED" },
      wechatpay: { background: "#51AA38", text: "#51AA38" },
      bocpay: { background: "#892130", text: "#892130" },
      octopus: { background: "#FF8600", text: "#FF8600" },
      bank_transfer: { background: "#79C462", text: "#79C462" },
      check_writing: { background: "#34B7BC", text: "#34B7BC" },
    };

    const backContainerStyle = {
      backgroundColor:
        paymentMethodColors[this.state.brand].background || "#FFFFFF", // Default color if brand is not found
    };

    const backContainerTextStyle = {
      color: paymentMethodColors[this.state.brand].text || "#FFFFFF", // Default color if brand is not found
    };

    return (
      <div className="ReceiptUpload-view">
        <div className="ReceiptUpload-prompt">
          <div className="ReceiptUpload-view1">
            <div
              className="ReceiptUpload-backContainer"
              onClick={() => {
                const dataObj = this.state;
                this.props.history.push({
                  pathname: "/SelectPayment",
                  state: dataObj,
                });
              }}
            >
              <div className="ReceiptUpload-back">
                <div
                  className="ReceiptUpload-backBtn"
                  style={backContainerStyle}
                />
                <div
                  className="ReceiptUpload-backText"
                  style={backContainerTextStyle}
                >
                  Back
                </div>
              </div>
            </div>
            <div
              className={`ReceiptUpload-paymentNetwork ${this.state.brand}`}
            />
            <div className="ReceiptUpload-text">
              <p>
                Please upload your {paymentMethodNames[this.state.brand]}{" "}
                receipt
              </p>
            </div>

            <div className="ReceiptUpload-QR"></div>

            <div className="ReceiptUpload-text">{languageObj.text2}</div>
          </div>
        </div>
      </div>
    );
  }
}

ReceiptUpload.propTypes = {
  languageObj: PropTypes.object,
  RenderFullPageLoading: PropTypes.func,
};

export default ReceiptUpload;
